import { render, staticRenderFns } from "./StudentToolbar.vue?vue&type=template&id=9be307cc"
import script from "./StudentToolbar.vue?vue&type=script&lang=js"
export * from "./StudentToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports